// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11ad1659","635":"00acc23c"}[chunkId] + ".chunk.js";
};